document.documentElement.classList.add('js');

function showToast(message) {
  const toast = document.querySelector('[data-toast]');
  if (!toast) return;
  toast.textContent = message;
  toast.hidden = false;
  clearTimeout(showToast.timer);
  showToast.timer = setTimeout(() => { toast.hidden = true; }, 3000);
}

/* Mobile drawer */
document.addEventListener('click', (e) => {
  if (e.target.closest('[data-drawer-open]')) {
    document.body.classList.add('drawer-open');
    document.querySelector('[data-drawer-open]').setAttribute('aria-expanded', 'true');
  } else if (e.target.closest('[data-drawer-close]')) {
    document.body.classList.remove('drawer-open');
    document.querySelector('[data-drawer-open]')?.setAttribute('aria-expanded', 'false');
  }
});
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') document.body.classList.remove('drawer-open');
});

/* Header search toggle */
document.addEventListener('click', (e) => {
  const toggle = e.target.closest('[data-search-toggle]');
  if (!toggle) return;
  const bar = document.querySelector('[data-search-bar]');
  bar.hidden = !bar.hidden;
  if (!bar.hidden) bar.querySelector('input').focus();
});

/* Back link: go back in history when we came from this store */
document.addEventListener('click', (e) => {
  const back = e.target.closest('[data-back]');
  if (back && document.referrer.startsWith(location.origin)) {
    e.preventDefault();
    history.back();
  }
});

/* Product gallery */
document.querySelectorAll('[data-gallery]').forEach((gallery) => {
  const main = gallery.querySelector('[data-gallery-main]');
  gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const img = main.querySelector('img');
      const next = img.cloneNode();
      next.src = thumb.dataset.src;
      next.srcset = thumb.dataset.srcset || '';
      img.replaceWith(next);
    });
  });
});

/* Add to bag without leaving the page */
document.querySelectorAll('[data-add-to-cart]').forEach((form) => {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const button = form.querySelector('[type="submit"]');
    button.setAttribute('aria-disabled', 'true');
    try {
      const root = window.Shopify?.routes?.root || '/';
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to bag');
      const cart = await (await fetch(`${root}cart.js`)).json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      const link = document.createElement('a');
      link.href = `${root}cart`;
      link.className = 'btn btn-primary';
      link.innerHTML = document.querySelector('[data-in-bag-template]')?.innerHTML || 'In Bag — View';
      form.replaceWith(link);
      showToast('Added to your bag');
    } catch (err) {
      button.removeAttribute('aria-disabled');
      showToast(err.message);
    }
  });
});

/* Collection: live search, category / condition filters and sorting (client side) */
document.querySelectorAll('[data-collection]').forEach((root) => {
  const grid = root.querySelector('[data-collection-grid]');
  if (!grid) return;
  const cards = Array.from(grid.children);
  const search = root.querySelector('[data-filter-search]');
  const category = root.querySelector('[data-filter-category]');
  const condition = root.querySelector('[data-filter-condition]');
  const sort = root.querySelector('[data-filter-sort]');
  const count = root.querySelector('[data-results-count]');
  const empty = root.querySelector('[data-empty]');
  const clear = root.querySelector('[data-clear-search]');
  const params = new URLSearchParams(location.search);

  if (search && params.get('q')) search.value = params.get('q');
  if (category && params.get('category')) category.value = params.get('category');
  if (condition && params.get('condition')) condition.value = params.get('condition');
  if (sort && params.get('sort')) sort.value = params.get('sort');

  const sorters = {
    newest: (a, b) => b.dataset.created - a.dataset.created,
    price_high: (a, b) => b.dataset.price - a.dataset.price,
    price_low: (a, b) => a.dataset.price - b.dataset.price,
    name: (a, b) => a.dataset.title.localeCompare(b.dataset.title),
  };

  function apply() {
    const q = (search?.value || '').trim().toLowerCase();
    const cat = category?.value || '';
    const cond = condition?.value || '';
    let shown = 0;
    cards.forEach((card) => {
      const match = (!q || card.dataset.search.includes(q))
        && (!cat || card.dataset.category === cat)
        && (!cond || card.dataset.condition === cond);
      card.hidden = !match;
      if (match) shown += 1;
    });
    if (sort) cards.slice().sort(sorters[sort.value] || sorters.newest).forEach((c) => grid.appendChild(c));
    if (count) count.textContent = `${shown} Piece${shown === 1 ? '' : 's'}`;
    if (empty) empty.hidden = shown !== 0;
    grid.hidden = shown === 0;
    if (clear) clear.hidden = !q;

    const next = new URLSearchParams(location.search);
    [['q', q], ['category', cat], ['condition', cond], ['sort', sort && sort.value !== 'newest' ? sort.value : '']]
      .forEach(([k, v]) => (v ? next.set(k, v) : next.delete(k)));
    const qs = next.toString();
    history.replaceState(null, '', location.pathname + (qs ? `?${qs}` : ''));
  }

  let timer;
  search?.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(apply, 250); });
  search?.closest('form')?.addEventListener('submit', (e) => { e.preventDefault(); apply(); });
  [category, condition, sort].forEach((el) => el?.addEventListener('change', apply));
  clear?.addEventListener('click', () => { search.value = ''; apply(); });
  apply();
});

/* Reveal product cards as they scroll into view */
if ('IntersectionObserver' in window) {
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('[data-reveal]').forEach((el) => io.observe(el));
} else {
  document.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-visible'));
}
